import { useState } from "react";
import { Copy, Play } from "@phosphor-icons/react";
import { toast } from "sonner";

/**
 * Shared doc-rendering primitives for the Publisher Integrations page.
 * Split out so the per-tab files don't each redeclare them.
 */

export function CodeBlock({ children }) {
  const copy = () => {
    navigator.clipboard.writeText(children);
    toast.success("Copied");
  };
  return (
    <div className="relative group">
      <pre className="bg-slate-900 text-slate-100 rounded-md px-4 py-3 text-xs font-mono overflow-x-auto leading-relaxed">{children}</pre>
      <button
        onClick={copy}
        className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity bg-slate-700 hover:bg-slate-600 text-white rounded p-1.5"
      >
        <Copy size={12} />
      </button>
    </div>
  );
}

export function CodeTabs({ snippets }) {
  const [lang, setLang] = useState("curl");
  const current = snippets[lang] || "";
  const copy = () => {
    navigator.clipboard.writeText(current);
    toast.success("Copied");
  };
  return (
    <div className="rounded-md overflow-hidden border border-slate-800">
      <div className="flex items-center gap-0 bg-slate-800 border-b border-slate-700">
        {["curl", "python", "node"].map((l) => (
          <button
            key={l}
            onClick={() => setLang(l)}
            className={`px-3 py-1.5 text-[11px] font-mono uppercase tracking-wider transition-colors ${
              lang === l ? "bg-slate-900 text-white" : "text-slate-400 hover:text-slate-200"
            }`}
            data-testid={`code-tab-${l}`}
          >
            {l === "node" ? "Node.js" : l === "curl" ? "cURL" : "Python"}
          </button>
        ))}
        <button
          onClick={copy}
          className="ml-auto px-3 py-1.5 text-[11px] text-slate-400 hover:text-white transition-colors flex items-center gap-1"
        >
          <Copy size={12} /> Copy
        </button>
      </div>
      <pre className="bg-slate-900 text-slate-100 px-4 py-3 text-xs font-mono overflow-x-auto leading-relaxed m-0">{current}</pre>
    </div>
  );
}

export function DocSection({ title, onTry, children }) {
  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-semibold text-slate-900">{title}</h4>
        {onTry && (
          <button
            type="button"
            onClick={onTry}
            className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#002FA7] hover:bg-[#002FA7] hover:text-white border border-[#002FA7]/30 px-2.5 py-1 rounded transition-colors"
            data-testid={`try-btn-${title.replace(/[^\w]/g, "-")}`}
          >
            <Play size={11} weight="fill" /> Try it
          </button>
        )}
      </div>
      {children}
    </div>
  );
}
